import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsCreatedPayload extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_CREATED;
    id: string;
    attributes: {
      aggregate: {
        projects_created: InsightMetric;
      };
    };
  };
}

export const parseProjectsCreatedPayload = (
  payload: BaseInsightPayload
): ProjectsCreatedPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_CREATED,
    data.attributes,
    false,
    true,
    ['projects_created']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { projects_created: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_CREATED,
      id: data.id,
      attributes: {
        aggregate: {
          projects_created: typedAttributes.aggregate.projects_created,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
